import React from "react";
import { observer } from "mobx-react-lite";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { getCurrentCulture } from "@utils";
import BettingTipsStore from "@state/quick-play-store/BettingTipsStore";
import { ChangePageButton } from "@state/quick-play-store/MostPlayedTicketsStore";
import BettingTipQuotaButton from "../BettingTipQuotaButton";
import { BettingTips } from "@api-types/bet-booster/BettingTipsType";
import { QuickPlayPopupsPagination } from "@features/quick-play/mobile/common/QuickPlayPopupsPagination";

export default observer(function BettingTipsPopupFooter(props: {
	store: BettingTipsStore;
	tip: BettingTips;
}) {
	const t = useTranslation().t;
	const location = useLocation();

	const isOnQuickPlayPage = location.pathname.includes("quick-play");
	const isPrevAndNextDisabled = props.store.bettingTips.length <= 1;

	return (
		<div className="popup__footer popup__footer--bordered">
			<BettingTipQuotaButton
				tip={props.tip}
				isInPopup
				store={props.store}
			/>

			<div className="popup__footer__row u-display--f--center">
				{props.store.currentTipIndex != null &&
					!isPrevAndNextDisabled && (
						<QuickPlayPopupsPagination
							onPrevClick={() => {
								props.store.changePage(
									ChangePageButton.PREVIOUS
								);
							}}
							onNextClick={() => {
								props.store.changePage(ChangePageButton.NEXT);
							}}
							isDisabled={isPrevAndNextDisabled}
							currentPage={props.store.currentTipIndex}
							totalPages={props.store.tips.size}
						/>
					)}
			</div>
			{!isOnQuickPlayPage && (
				<Link
					to={`/${getCurrentCulture()}/quick-play/betting-tips`}
					className="btn btn--sml btn--block btn--ghost popup__btn popup__btn--tertiary"
					onClick={props.store.deactivatePopup}
				>
					<span className="btn__label">{t("COMMON.SHOW_MORE")}</span>
				</Link>
			)}
		</div>
	);
});
